module.exports = "<div class=\"endorsement\">\n  <div class=\"endorsement-body\">\n    <p>\n      <i class=\"fa fa-quote-left\" aria-hidden=\"true\"></i>\n        <ng-content select=\"endorsement-body\"></ng-content>\n      <i class=\"fa fa-quote-right\" aria-hidden=\"true\"></i>\n    </p>\n    <div class=\"endorsement-author\">\n      <ng-content select=\"endorsement-author\"></ng-content>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/jonshilton/Projects/nick-smith-app/src/app/modules/endorsement/endorsement.html
// module id = ../../../../../src/app/modules/endorsement/endorsement.html
// module chunks = 0